import React, { Component } from "react";
import Button from "../Button/Button";
import {Link} from 'react-router-dom';
import "./SignIn.css";

class SignIn extends Component {
	checkboxCheck(e) {
		console.log(e);
	}
	
	onClick(){
    	window.location.href='/signup';
	}
	
	onClick2(){
    	window.location.href='https://www.fmeasure.com/app/?page=market_research_report';
	}
	
	render() {
		return (
			<div className="container sign-in">
				<h2 className="mb-20">M&A Service User Login</h2>
				<form onSubmit={e => this.props.postLogin(e)}>
					<label>Email</label>
					<input
						type="email"
						value={this.props.loginParams["user"]}
						onChange={e => {
							this.props.onChangeInput("user", e.target.value, 'loginParams');
						}}
					/>
					<label>Password</label>
					<input
						type="password"
						value={this.props.loginParams["pass"]}
						onChange={e => {
							this.props.onChangeInput("pass", e.target.value, 'loginParams');
						}}
					/>
					<div className="cookie-set-row">
						<input
							type="checkbox"
							checked={this.props.loginParams["cookieFlag"]}
							onChange={e => {
								this.props.onChangeInput("cookieFlag", true, 'loginParams');
							}}
						/>
						<p>Remember me</p>
					</div>
					<div>
					<Button label="Sign In" />
					</div>
				</form>			

			
				<p></p><p></p><p></p><p></p><p></p>


				<div align="center">
					<h2 className="mb-20">Not a User? Sign Up Here</h2>
					<div style={{padding: '25px'}, {marginRight: '20'}, {display: 'inline-block'}}>
						<label>M&A service <b>Standard Monthly Plan</b>: 198 USD/Month; &nbsp;&nbsp;&nbsp;<br></br><a href="https://www.fmeasure.com/contact-us/">Contact us</a> for details of other plans.</label>
						<br></br>
						<button title="198.00 USD/Month" onClick= {this.onClick}>
						  	<b>M&A Service Monthly Plan Sign Up</b>
						</button>&nbsp;&nbsp;&nbsp;
					</div>

					<div style={{padding: '25px'}, {marginRight: '20'}, {display: 'inline-block'}}>
						Only need a <b>One Time Use</b> of the service? No problem! <br></br>&nbsp;&nbsp;&nbsp;We generate a buyer list for a one time charge: 69.99 USD.
						<br></br>
						<button title= "69.99 USD /Use" onClick= {this.onClick2}>
						  	<b>Market Research Report (One Time Use)</b>
						</button>
					</div>
					<p></p>
					<label><i>By signing up to our services, you acknowledge that you have <br></br>read and agreed to our <a href= "https://www.fmeasure.com/wp-content/uploads/2018/11/term_of_use.pdf">Terms of Use</a> and <a href= "https://www.fmeasure.com/wp-content/uploads/2018/11/privacy_policy.pdf">Privacy Policy</a>.</i></label>
					<br></br>
				</div>
			</div>
		);
	}
}

export default SignIn;


// WEBPACK FOOTER //
// ./src/components/SignIn/SignIn.js